<template>
<div style="margin-top: 113px">
  <v-container class="message-container">
    <v-row class="row-password" justify="center" align="center">
      <v-alert dense text :type="msgType">
        {{msg}}
      </v-alert>
    </v-row>
    <div>
      <a href="/"> Back to home </a>
    </div>
    <div v-if="msgType=='error'">
      <a href="javascript:history.back()"> Back to password change </a>
    </div>

  </v-container>
</div>
</template>

<style scoped>
.row-password {
  height: 200px;
  padding-top: 0;
  padding-bottom: 0;
  margin: 0;
}

.message-container {
  padding-top: 0;
  padding-bottom: 0;
  margin: 0;
}
</style>

<script>
export default {
  name: 'ChangePassword',
  data() {
    return {
      msg: '',
      msgType: 'success'
    }
  },
  mounted: function () {
    this.$store.dispatch("hideUser");
    if (this.$route.params.status == 'success') {
      this.msg = 'Password successfully changed';
      this.msgType = 'success';
    } else {
      this.msg = 'Error while changing password';
      this.msgType = 'error';
    }
    if (this.$route.query.details != undefined && this.$route.query.details != "") {
      this.msg += ' : ' + this.$route.query.details;
    }
  }
}
</script>
